<template>
  <div
    v-if="value"
    class="display-event-products-purchased ma-auto"
    :class="forceWhite ? 'text-white' : ''"
  >
    <div
      :class="value.limitPurchasesForPublicRegistration ? 'connect-bottom' : ''"
      data-test="products-count"
    >
      <span class="d-block">{{ value.confirmedPurchasesCount }}</span>
    </div>
    <div
      v-if="value.limitPurchasesForPublicRegistration"
      data-test="max-products"
    >
      <span class="d-block">{{
        value.limitPurchasesForPublicRegistration
      }}</span>
      Max
    </div>
  </div>
</template>
<script>
export default {
  name: "AppShowEventProductsPurchased",
  props: {
    value: {
      type: Object,
      default: null
    },
    forceWhite: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped lang="scss">
.display-event-products-purchased {
  display: flex;
  flex-direction: column;
  min-height: 24px;
  min-width: 24px;
  max-width: 32px;

  & > div {
    line-height: 1.2;
    font-size: 10px;
    border-radius: 5px;
    border: 1px solid rgb(var(--v-theme-secondary));
    color: rgb(var(--v-theme-secondary));
    text-align: center;
    padding: 0.25em;
    width: 100%;
    min-height: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &.connect-bottom {
      border-radius: 5px 5px 0 0;
    }
  }

  & > div + div {
    & {
      border-radius: 0px 0px 5px 5px;
      border-top: 0;
    }
  }

  &.text-white {
    & > div {
      border-color: white;
      color: white;
    }
  }
}
</style>
